
export interface Project {
  id: string;
  title: string;
  tech: string[];
  period: string;
  manager?: string;
  description: string;
  fullDescription: string;
  status: string;
  statusColor: string;
  image: string;
  gallery?: string[];
  github?: string;
  link?: string;
  category: 'backend' | 'frontend' | 'mobile';
  features: string[];
  challenges: string[];
  results: string[];
}

export const projects: Project[] = [
  // Backend Projects
  {
    id: "sonatel-academy-backend",
    title: "Sonatel Academy – Plateforme de Gestion des Apprenants",
    tech: ["Laravel", "PHP", "MySQL", "Docker", "GitLab CI/CD", "Nginx", "Kubernetes"],
    period: "2025 – Présent",
    manager: "Birane Baila Wane",
    description: "Développement d'API REST sécurisées avec Laravel et authentification JWT. Gestion des rôles utilisateurs, CI/CD avec GitLab, conteneurisation Docker et orchestration Kubernetes.",
    fullDescription: "Ce projet ambitieux vise à moderniser la gestion des apprenants au sein de Sonatel Academy. La plateforme permet une gestion complète du parcours des étudiants, depuis leur inscription jusqu'à leur certification. L'architecture backend repose sur Laravel avec une API REST robuste et sécurisée par JWT. Le système intègre une gestion fine des rôles (administrateurs, formateurs, apprenants) avec des permissions granulaires.",
    status: "En Production",
    statusColor: "bg-[#00FF88]",
    category: "backend",
    image: "https://readdy.ai/api/search-image?query=modern%20enterprise%20learning%20management%20system%20dashboard%20with%20clean%20interface%20showing%20student%20analytics%20and%20course%20management%20features%20on%20laptop%20screen%20in%20professional%20office%20environment%20with%20soft%20lighting%20and%20minimalist%20background%20technology%20workspace%20aesthetic&width=800&height=500&seq=sonatel1&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=api%20documentation%20swagger%20interface%20with%20endpoints%20and%20authentication%20methods%20displayed%20on%20monitor%20in%20modern%20development%20workspace%20with%20clean%20white%20background%20professional%20software%20documentation&width=800&height=500&seq=sonatelgal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=kubernetes%20cluster%20dashboard%20showing%20pods%20deployments%20and%20services%20monitoring%20on%20screen%20in%20devops%20workspace%20with%20minimalist%20background%20container%20orchestration%20interface&width=800&height=500&seq=sonatelgal2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=database%20schema%20diagram%20with%20tables%20relationships%20and%20indexes%20displayed%20on%20large%20monitor%20in%20software%20architecture%20workspace%20with%20clean%20background%20data%20modeling%20interface&width=800&height=500&seq=sonatelgal3&orientation=landscape"
    ],
    features: [
      "API REST complète avec authentification JWT",
      "Gestion des rôles et permissions (RBAC)",
      "Pipeline CI/CD automatisé avec GitLab",
      "Conteneurisation Docker et orchestration Kubernetes",
      "Documentation Swagger interactive",
      "Tests unitaires et d'intégration",
      "Monitoring et logging centralisé"
    ],
    challenges: [
      "Mise en place d'une architecture microservices scalable",
      "Optimisation des performances pour gérer des milliers d'utilisateurs",
      "Intégration continue avec déploiement zero-downtime",
      "Sécurisation des données sensibles des apprenants"
    ],
    results: [
      "Réduction de 60% du temps de gestion administrative",
      "99.9% de disponibilité du service",
      "Temps de déploiement réduit de 2h à 15 minutes",
      "Satisfaction utilisateur de 4.8/5"
    ]
  },
  {
    id: "fotol-jay-backend",
    title: "Fotol Jay – API Marketplace E-commerce",
    tech: ["Node.js", "Express", "MongoDB", "Jenkins", "Docker", "Kubernetes"],
    period: "2024 – 2025",
    manager: "Aly Tall Niang",
    description: "API REST pour marketplace type Expat Dakar, avec publication d'annonces, rôles utilisateurs, modération et photos prises directement au moment du dépôt.",
    fullDescription: "Fotol Jay est une plateforme e-commerce de petites annonces inspirée d'Expat Dakar, avec un principe fort de confiance : les produits publiés doivent être photographiés directement depuis l'application au moment du dépôt, au lieu d'importer des images depuis la galerie. Le backend gère les annonces, catégories, utilisateurs, rôles, modération, médias, notifications et règles de publication afin de limiter les faux produits et d'améliorer la fiabilité des annonces.",
    status: "Déployée",
    statusColor: "bg-[#0066FF]",
    category: "backend",
    image: "https://readdy.ai/api/search-image?query=cloud%20photo%20storage%20and%20management%20system%20interface%20with%20image%20gallery%20grid%20upload%20features%20and%20modern%20dashboard%20on%20computer%20screen%20in%20creative%20studio%20with%20clean%20white%20background%20professional%20photography%20workspace&width=800&height=500&seq=fotoljay1&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=cloudinary%20media%20management%20dashboard%20with%20image%20transformations%20and%20cdn%20delivery%20stats%20on%20monitor%20in%20tech%20workspace%20with%20minimal%20background%20cloud%20storage%20interface&width=800&height=500&seq=fotolgal1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=mongodb%20compass%20database%20interface%20showing%20collections%20documents%20and%20queries%20on%20screen%20in%20developer%20workspace%20with%20clean%20background%20nosql%20database%20management&width=800&height=500&seq=fotolgal2&orientation=landscape"
    ],
    features: [
      "Publication d'annonces e-commerce",
      "Prise de photo directe obligatoire pour les produits",
      "API REST performante avec Express",
      "Base de données MongoDB flexible",
      "Gestion des utilisateurs, rôles et modération",
      "Pipeline CI/CD avec Jenkins",
      "Déploiement automatisé sur Kubernetes"
    ],
    challenges: [
      "Limiter les fausses annonces et faux produits",
      "Empêcher l'import d'images non prises depuis l'application",
      "Structurer une marketplace fiable et modérable"
    ],
    results: [
      "Parcours de dépôt d'annonce plus fiable",
      "Meilleure confiance entre acheteurs et vendeurs",
      "Base backend prête pour une marketplace locale"
    ]
  },
  {
    id: "sama-bankmanager-backend",
    title: "Sama-BankManager – Backend Bancaire",
    tech: ["Laravel", "PHP", "MySQL", "Jenkins", "Docker", "Kubernetes"],
    period: "2023 – 2024",
    manager: "Birane Baila Wane",
    description: "Développement du backend bancaire (transactions, comptes, rôles utilisateurs). API REST sécurisées, documentation Swagger, tests unitaires.",
    fullDescription: "Sama-BankManager est une solution bancaire complète développée pour gérer les opérations financières critiques. Le backend assure la sécurité maximale des transactions, la gestion des comptes clients et la conformité réglementaire. L'architecture Laravel garantit robustesse et maintenabilité.",
    status: "Production",
    statusColor: "bg-[#00FF88]",
    category: "backend",
    image: "https://readdy.ai/api/search-image?query=secure%20banking%20application%20dashboard%20showing%20financial%20transactions%20account%20management%20and%20security%20features%20on%20modern%20laptop%20in%20professional%20banking%20office%20with%20clean%20minimalist%20background%20fintech%20technology%20aesthetic&width=800&height=500&seq=samabank1&orientation=landscape",
    features: [
      "Gestion sécurisée des transactions bancaires",
      "Système de comptes multi-devises",
      "Authentification forte à deux facteurs",
      "Audit trail complet des opérations",
      "API REST documentée avec Swagger",
      "Tests unitaires et d'intégration"
    ],
    challenges: [
      "Sécurisation des données financières sensibles",
      "Conformité aux normes bancaires",
      "Haute disponibilité 24/7"
    ],
    results: [
      "Zéro incident de sécurité",
      "100% de conformité réglementaire",
      "Traitement de milliers de transactions/jour"
    ]
  },
  {
    id: "ges-paiement-backend",
    title: "Ges_Paiement_Employeur – API de Gestion des Paiements",
    tech: ["Node.js", "Express", "MongoDB", "Docker", "GitLab CI/CD"],
    period: "2024",
    manager: "Aly Tall Niang",
    description: "API REST pour la gestion des employeurs et des paiements. Authentification JWT, transactions sécurisées, automatisation des déploiements.",
    fullDescription: "Cette API gère l'ensemble du cycle de paiement des employeurs : création de fiches de paie, calcul automatique des cotisations, génération de rapports et intégration avec les systèmes bancaires. L'architecture Node.js assure des performances optimales pour le traitement en masse.",
    status: "Production",
    statusColor: "bg-[#00FF88]",
    category: "backend",
    image: "https://readdy.ai/api/search-image?query=payroll%20management%20system%20interface%20with%20payment%20processing%20employee%20data%20and%20financial%20reports%20on%20desktop%20screen%20in%20modern%20office%20workspace%20with%20soft%20neutral%20background%20business%20technology%20environment&width=800&height=500&seq=gespaiement1&orientation=landscape",
    features: [
      "Calcul automatique des salaires et cotisations",
      "Génération de bulletins de paie PDF",
      "Intégration bancaire pour virements",
      "Gestion multi-entreprises",
      "Rapports et statistiques avancés"
    ],
    challenges: [
      "Calculs complexes de paie conformes à la législation",
      "Intégration avec multiples systèmes bancaires"
    ],
    results: [
      "Automatisation de 95% des processus de paie",
      "Réduction des erreurs de calcul à zéro"
    ]
  },
  {
    id: "projet-maxit-backend",
    title: "ProjetMaxit – API de Gestion d'Entreprise",
    tech: ["Laravel", "PHP", "MySQL", "Stripe API", "Docker"],
    period: "2023",
    manager: "Birane Baila Wane",
    description: "Backend complet pour la gestion commerciale avec intégration Stripe API, pipeline CI/CD automatisé.",
    fullDescription: "ProjetMaxit est une solution ERP légère pour PME, couvrant la gestion commerciale, la facturation et les paiements en ligne. L'intégration Stripe permet des transactions sécurisées et un suivi en temps réel des revenus.",
    status: "Terminé",
    statusColor: "bg-gray-500",
    category: "backend",
    image: "https://readdy.ai/api/search-image?query=business%20management%20software%20dashboard%20with%20sales%20analytics%20payment%20integration%20and%20commercial%20tracking%20features%20on%20computer%20in%20contemporary%20office%20with%20clean%20white%20background%20enterprise%20software%20aesthetic&width=800&height=500&seq=maxit1&orientation=landscape",
    features: [
      "Gestion des clients et fournisseurs",
      "Facturation automatisée",
      "Paiements en ligne via Stripe",
      "Tableau de bord analytique",
      "Export comptable"
    ],
    challenges: [
      "Intégration fluide avec Stripe",
      "Gestion des devises multiples"
    ],
    results: [
      "Augmentation de 30% des paiements en ligne",
      "Réduction du délai de paiement moyen"
    ]
  },
  {
    id: "api-gestion-paie",
    title: "API de Gestion de la Paie",
    tech: ["Node.js", "Prisma", "MySQL", "Swagger", "JWT"],
    period: "2025",
    description: "API REST pour gestion multi-entreprises, employés, paie, congés. RBAC, multitenancy, webhooks.",
    fullDescription: "Une API moderne et complète pour la gestion de la paie, conçue avec une architecture multitenancy permettant à plusieurs entreprises d'utiliser la même instance. Prisma ORM assure des requêtes optimisées et une migration de schéma fluide.",
    status: "Backend",
    statusColor: "bg-[#8B5CF6]",
    category: "backend",
    link: "http://localhost:3000/api-docs",
    image: "https://readdy.ai/api/search-image?query=comprehensive%20payroll%20api%20documentation%20interface%20with%20swagger%20endpoints%20employee%20management%20features%20on%20laptop%20screen%20in%20professional%20tech%20workspace%20with%20minimalist%20light%20background%20modern%20software%20development%20environment&width=800&height=500&seq=paieapi1&orientation=landscape",
    features: [
      "Architecture multitenancy",
      "Gestion RBAC avancée",
      "Webhooks pour intégrations tierces",
      "Documentation Swagger complète",
      "Gestion des congés et absences"
    ],
    challenges: [
      "Isolation des données entre entreprises",
      "Performance avec Prisma sur gros volumes"
    ],
    results: [
      "API utilisée par 10+ entreprises",
      "Documentation 100% couverte"
    ]
  },
  {
    id: "api-restful-node",
    title: "API_Restful NodeExpress – Gestion Étudiants",
    tech: ["Node.js", "Express", "MongoDB", "Docker", "GitHub Actions"],
    period: "2022 – 2023",
    description: "API REST avec CRUD complet et middlewares d'authentification. Intégration continue via GitHub Actions.",
    fullDescription: "Projet académique devenu référence pour l'apprentissage des API REST. Cette API gère les étudiants, cours et notes avec une architecture propre et bien documentée. Parfait exemple de bonnes pratiques Node.js.",
    status: "Terminé",
    statusColor: "bg-gray-500",
    category: "backend",
    image: "https://readdy.ai/api/search-image?query=student%20management%20api%20interface%20with%20crud%20operations%20authentication%20middleware%20and%20github%20actions%20pipeline%20on%20development%20screen%20in%20modern%20coding%20workspace%20with%20clean%20background%20software%20engineering%20environment&width=800&height=500&seq=apirestful1&orientation=landscape",
    features: [
      "CRUD complet pour étudiants et cours",
      "Middlewares d'authentification",
      "Validation des données",
      "CI/CD avec GitHub Actions",
      "Tests automatisés"
    ],
    challenges: [
      "Structuration propre du code",
      "Gestion des erreurs cohérente"
    ],
    results: [
      "Projet utilisé comme référence pédagogique",
      "100% de couverture de tests"
    ]
  },
  {
    id: "fotol-jay-api-backend",
    title: "FOTOL JAY API Backend",
    tech: ["Node.js", "Express.js", "Prisma", "Redis", "Firebase", "Swagger"],
    period: "2025",
    description: "API backend pour plateforme de vente de produits d'occasion. Auth JWT, Socket.io, gestion VIP, cache Redis, rôles (User, VIP, Pro, Modérateur, Admin).",
    fullDescription: "Backend complet pour une marketplace de produits d'occasion. Architecture sophistiquée avec cache Redis pour les performances, Socket.io pour le temps réel, et un système de rôles hiérarchique permettant différents niveaux d'accès et de fonctionnalités.",
    status: "Backend",
    statusColor: "bg-[#8B5CF6]",
    category: "backend",
    image: "https://readdy.ai/api/search-image?query=marketplace%20backend%20api%20architecture%20with%20redis%20caching%20firebase%20integration%20and%20role%20based%20access%20control%20system%20on%20development%20monitor%20in%20professional%20tech%20office%20with%20minimalist%20background%20modern%20api%20development&width=800&height=500&seq=fotolbackend1&orientation=landscape",
    features: [
      "Système de rôles hiérarchique",
      "Cache Redis pour performances",
      "Temps réel avec Socket.io",
      "Notifications Firebase",
      "Gestion des abonnements VIP/Pro"
    ],
    challenges: [
      "Gestion complexe des permissions",
      "Synchronisation temps réel à grande échelle"
    ],
    results: [
      "Latence réduite de 80% grâce au cache",
      "Support de milliers de connexions simultanées"
    ]
  },
  // Frontend Projects
  {
    id: "c2p-platform",
    title: "C2P – Plateforme SaaS Collaborative",
    tech: ["React.js", "NestJS", "TypeScript", "PostgreSQL", "JWT", "WebSocket", "Swagger", "RBAC", "Docker", "Nginx"],
    period: "2026",
    description: "Plateforme SaaS collaborative centralisant utilisateurs, accès, espaces de travail, messagerie, notifications, audit et modules métier C2P.",
    fullDescription: "C2P est une plateforme web SaaS conçue pour centraliser l'écosystème C2P autour d'une interface unique : AlloPresta, espace numérique, ProjectCenter, partenaires, certificats et administration. L'architecture cible repose sur un frontend React.js et un backend NestJS en monolithe modulaire, avec PostgreSQL, API REST, WebSocket, JWT, RBAC, Swagger/OpenAPI et audit logs. La plateforme vise à gérer les utilisateurs, rôles, permissions, workspaces, invitations, messagerie temps réel, notifications, statistiques et supervision administrative, tout en gardant une base technique évolutive inspirée de Clean Architecture et DDD.",
    status: "En Production",
    statusColor: "bg-[#00FF88]",
    category: "frontend",
    image: "/images/projects/c2p-platform.png",
    gallery: [
      "/images/projects/c2p-platform.png"
    ],
    features: [
      "Écosystème web C2P avec modules AlloPresta, formations et ProjectCenter",
      "Authentification JWT avec refresh token et récupération de mot de passe",
      "Gestion utilisateurs, profils, statuts, rôles et permissions RBAC",
      "Workspaces, organisations, membres et invitations",
      "Messagerie et notifications temps réel via WebSocket",
      "Dashboard administrateur, statistiques et audit logs",
      "Documentation API Swagger/OpenAPI"
    ],
    challenges: [
      "Structurer une plateforme SaaS sans surcomplexifier l'architecture",
      "Isoler les responsabilités dans un monolithe modulaire NestJS",
      "Sécuriser les accès avec RBAC et contrôles backend",
      "Centraliser plusieurs modules métier dans une expérience cohérente"
    ],
    results: [
      "Vision produit claire pour un écosystème C2P unifié",
      "Architecture prête pour collaboration, administration et temps réel",
      "Base technique évolutive avec React, NestJS et PostgreSQL",
      "Fondation solide pour ajouter de nouveaux modules métier"
    ]
  },
  {
    id: "quizzboard",
    title: "QuizzBoard – Plateforme Interactive de Quiz",
    tech: ["React.js", "Flutter", "Node.js", "PostgreSQL", "JWT", "Google Sign-In", "WebSocket", "IA", "Paiement", "Nginx"],
    period: "2026",
    description: "Plateforme EdTech web/mobile pour créer des quiz, lancer des sessions avec code, faire participer les apprenants en temps réel et analyser les résultats.",
    fullDescription: "QuizzBoard est une plateforme interactive de quiz et de sessions pédagogiques destinée aux enseignants, formateurs, apprenants et administrateurs. Un professeur crée un quiz, lance une session, obtient un code de participation et les apprenants rejoignent l'activité depuis le web ou le mobile. La plateforme gère les questions, réponses, participants, résultats, notifications, authentification classique ou Google Sign-In, administration, paiement et fonctionnalités IA autour des quiz. Le projet a aussi une forte dimension production : stabilisation du backend, correction des rôles, configuration PostgreSQL, sauvegardes, déploiement sur VPS Linux, Nginx, variables d'environnement et workflows DevOps.",
    status: "Production",
    statusColor: "bg-[#00FF88]",
    category: "frontend",
    image: "/images/projects/quizzboard-showcase.png",
    gallery: [
      "/images/projects/quizzboard-showcase.png",
      "https://readdy.ai/api/search-image?query=mobile%20quiz%20app%20screen%20for%20student%20joining%20session%20with%20code%20answering%20questions%20and%20viewing%20results%20clean%20educational%20interface&width=800&height=500&seq=quizzboardgal2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=admin%20analytics%20dashboard%20for%20quiz%20platform%20showing%20users%20sessions%20payments%20notifications%20and%20performance%20charts%20professional%20saas%20interface&width=800&height=500&seq=quizzboardgal3&orientation=landscape"
    ],
    features: [
      "Création de quiz, questions, réponses et choix",
      "Sessions pédagogiques avec code de participation",
      "Participation apprenant web/mobile et résultats de session",
      "Temps réel avec WebSocket pour les quiz interactifs",
      "Authentification JWT et Google Sign-In",
      "Administration, notifications et module de paiement",
      "Fonctionnalités IA autour des quiz et réponses"
    ],
    challenges: [
      "Stabiliser une application existante en production",
      "Corriger la logique des rôles et protéger les routes sensibles",
      "Sécuriser la configuration PostgreSQL et les environnements",
      "Fiabiliser les sessions temps réel, paiements, notifications et IA"
    ],
    results: [
      "Plateforme EdTech web/mobile prête pour des sessions interactives",
      "Backend et base PostgreSQL stabilisés pour la production",
      "Déploiement VPS Linux avec Nginx, sauvegardes et variables d'environnement",
      "Parcours critique couvert : quiz, session, code, participation, réponses, résultats"
    ]
  },
  {
    id: "kafountine-gestion-municipale",
    title: "Kafountine – Plateforme de Gestion Municipale",
    tech: ["React.js", "Node.js", "Express.js", "PostgreSQL", "Prisma", "Zod", "JWT", "RBAC", "Docker", "Nginx"],
    period: "2026",
    description: "Plateforme web de dématérialisation des démarches municipales : demandes citoyennes, justificatifs, affectation aux services, suivi de dossiers, notifications et audit.",
    fullDescription: "Kafountine est une plateforme complète de gestion municipale destinée à digitaliser les démarches administratives d'une mairie. Les citoyens créent des demandes en ligne, transmettent leurs pièces justificatives et suivent l'évolution de leurs dossiers. Les agents, responsables de service et administrateurs disposent de dashboards pour affecter, traiter, valider ou rejeter les demandes, avec historique complet, notifications internes, statistiques et journaux d'audit. Techniquement, l'application repose sur un frontend React.js connecté à une API REST Node.js/Express.js organisée en monolithe modulaire, avec Prisma, PostgreSQL, validation Zod, authentification JWT, autorisation RBAC, Docker, Nginx et déploiement VPS.",
    status: "En Production",
    statusColor: "bg-[#00FF88]",
    category: "frontend",
    image: "/images/projects/kafountine-dashboard.png",
    gallery: [
      "/images/projects/kafountine-dashboard.png",
      "https://readdy.ai/api/search-image?query=municipal%20agent%20case%20management%20dashboard%20with%20assigned%20requests%20verification%20documents%20workflow%20actions%20and%20service%20statistics%20professional%20government%20software%20screen&width=800&height=500&seq=kafountinegal2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=secure%20admin%20dashboard%20for%20municipal%20platform%20with%20users%20roles%20permissions%20services%20audit%20logs%20charts%20and%20reports%20modern%20enterprise%20interface&width=800&height=500&seq=kafountinegal3&orientation=landscape"
    ],
    features: [
      "Espace citoyen pour créer et suivre les demandes",
      "Catalogue configurable des démarches administratives",
      "Upload sécurisé des pièces justificatives",
      "Workflow de traitement avec statuts et affectations",
      "Dashboards agent, responsable de service et administrateur",
      "Notifications internes sur l'évolution des dossiers",
      "RBAC, audit logs et historique complet des opérations"
    ],
    challenges: [
      "Modéliser un workflow administratif clair et traçable",
      "Sécuriser l'accès aux documents et données citoyennes",
      "Concevoir une architecture modulaire sans complexité inutile",
      "Gérer finement les rôles, permissions et périmètres de service"
    ],
    results: [
      "Réduction des déplacements inutiles des citoyens",
      "Centralisation des dossiers et justificatifs municipaux",
      "Traçabilité complète des validations, rejets et affectations",
      "Base technique prête pour statistiques, exports et notifications avancées"
    ]
  },
  {
    id: "sonatel-academy-frontend",
    title: "Sonatel Academy – Plateforme de Gestion des Apprenants",
    tech: ["Angular", "TypeScript", "SCSS", "Docker", "GitLab CI/CD", "Nginx"],
    period: "2025 – Présent",
    manager: "Aly Tall Niang",
    description: "Développement d'interfaces dynamiques en Angular, intégration des API REST Laravel, authentification JWT, pipelines CI/CD.",
    fullDescription: "Interface utilisateur moderne et intuitive pour la plateforme Sonatel Academy. Développée en Angular avec TypeScript pour une maintenabilité optimale. L'application offre une expérience fluide aux apprenants et formateurs avec des tableaux de bord personnalisés.",
    status: "En Production",
    statusColor: "bg-[#00FF88]",
    category: "frontend",
    image: "https://readdy.ai/api/search-image?query=modern%20angular%20web%20application%20interface%20with%20student%20dashboard%20course%20management%20and%20learning%20analytics%20displayed%20on%20desktop%20monitor%20in%20bright%20office%20with%20clean%20white%20background%20educational%20technology%20platform&width=800&height=500&seq=sonatelfront1&orientation=landscape",
    features: [
      "Tableaux de bord personnalisés par rôle",
      "Gestion des cours et modules",
      "Suivi de progression des apprenants",
      "Système de notifications en temps réel",
      "Interface responsive et accessible"
    ],
    challenges: [
      "UX complexe pour différents profils utilisateurs",
      "Performance avec grandes quantités de données"
    ],
    results: [
      "Taux d'adoption de 95% par les utilisateurs",
      "Score d'accessibilité WCAG AA"
    ]
  },
  {
    id: "fotol-jay-frontend",
    title: "Fotol Jay – Marketplace E-commerce",
    tech: ["React.js", "TypeScript", "Redux", "Tailwind CSS", "Firebase", "Jenkins", "Kubernetes"],
    period: "2024 – 2025",
    manager: "Aly Tall Niang",
    description: "Interface marketplace type Expat Dakar pour publier, rechercher et consulter des produits, avec dépôt d'annonce basé sur des photos prises directement dans l'application.",
    fullDescription: "Fotol Jay est une application e-commerce de petites annonces pensée pour rendre les publications plus fiables. Contrairement aux plateformes où l'on peut importer n'importe quelle image, Fotol Jay impose la prise de photo directe du produit au moment de la publication. L'objectif est de réduire les faux produits, renforcer la confiance et proposer une expérience proche d'Expat Dakar avec recherche, catégories, annonces, profils vendeurs, notifications et parcours de publication guidé.",
    status: "Déployée",
    statusColor: "bg-[#0066FF]",
    category: "frontend",
    image: "https://readdy.ai/api/search-image?query=beautiful%20react%20photo%20gallery%20application%20interface%20with%20image%20grid%20upload%20buttons%20and%20modern%20ui%20design%20on%20laptop%20in%20creative%20workspace%20with%20soft%20lighting%20and%20minimal%20background%20photography%20app%20aesthetic&width=800&height=500&seq=fotolfront1&orientation=landscape",
    features: [
      "Catalogue d'annonces avec catégories et recherche",
      "Publication de produit avec photo prise directement",
      "Parcours vendeur pour créer et gérer ses annonces",
      "Filtres avancés pour retrouver les produits",
      "Notifications push Firebase",
      "Mode sombre/clair"
    ],
    challenges: [
      "Concevoir un dépôt d'annonce qui évite les fausses images",
      "Rendre le parcours de publication simple malgré la contrainte photo",
      "Gestion d'état complexe avec Redux"
    ],
    results: [
      "Marketplace plus fiable pour acheteurs et vendeurs",
      "Réduction du risque de faux produits",
      "Expérience de publication claire et rapide"
    ]
  },
  {
    id: "ges-paiement-frontend",
    title: "Ges_Paiement_Employeur – Tableau de Bord Employeur",
    tech: ["Vue.js", "TypeScript", "Pinia", "Axios", "Tailwind CSS", "Docker"],
    period: "2024",
    manager: "Aly Tall Niang",
    description: "Tableau de bord et modules analytiques avec Vue 3 (Composition API), authentification JWT, lazy loading.",
    fullDescription: "Interface de gestion des paiements employeurs développée avec Vue 3 et la Composition API. Pinia gère l'état de manière réactive, et les graphiques interactifs permettent une analyse approfondie des données de paie.",
    status: "Production",
    statusColor: "bg-[#00FF88]",
    category: "frontend",
    image: "https://readdy.ai/api/search-image?query=vue%20js%20employer%20dashboard%20with%20payment%20analytics%20charts%20employee%20data%20tables%20and%20modern%20interface%20on%20computer%20screen%20in%20professional%20office%20with%20clean%20neutral%20background%20business%20analytics%20platform&width=800&height=500&seq=gesfront1&orientation=landscape",
    features: [
      "Tableaux de bord analytiques",
      "Graphiques interactifs",
      "Export de rapports PDF/Excel",
      "Gestion des employés",
      "Historique des paiements"
    ],
    challenges: [
      "Visualisation de données complexes",
      "Performance avec grands datasets"
    ],
    results: [
      "Réduction de 50% du temps de reporting",
      "Interface intuitive validée par les utilisateurs"
    ]
  },
  {
    id: "sama-bankmanager-frontend",
    title: "Sama-BankManager – Application Bancaire",
    tech: ["Vue.js", "JavaScript", "Vuex", "Chart.js", "Bootstrap"],
    period: "2023 – 2024",
    manager: "Birane Baila Wane",
    description: "Tableaux de bord clients et administrateurs, composants UI réutilisables, intégration de graphiques.",
    fullDescription: "Interface bancaire complète avec Vue.js offrant des tableaux de bord distincts pour clients et administrateurs. Chart.js permet des visualisations financières claires et Bootstrap assure une interface professionnelle.",
    status: "Production",
    statusColor: "bg-[#00FF88]",
    category: "frontend",
    image: "https://readdy.ai/api/search-image?query=banking%20web%20application%20dashboard%20with%20financial%20charts%20account%20overview%20and%20transaction%20history%20on%20desktop%20in%20modern%20banking%20office%20with%20minimalist%20white%20background%20fintech%20interface%20design&width=800&height=500&seq=samabankfront1&orientation=landscape",
    features: [
      "Dashboard client personnalisé",
      "Interface administrateur complète",
      "Graphiques financiers interactifs",
      "Historique des transactions",
      "Gestion des virements"
    ],
    challenges: [
      "Sécurité de l'interface bancaire",
      "UX pour opérations sensibles"
    ],
    results: [
      "Zéro erreur utilisateur sur les transactions",
      "Satisfaction client de 4.6/5"
    ]
  },
  {
    id: "projet-maxit-frontend",
    title: "ProjetMaxit – Application de Gestion Commerciale",
    tech: ["React.js", "JavaScript", "Tailwind CSS", "Axios", "Docker"],
    period: "2023",
    manager: "Birane Baila Wane",
    description: "Tableaux de bord et interfaces de suivi d'activités, amélioration UX/UI.",
    fullDescription: "Interface de gestion commerciale React avec focus sur l'expérience utilisateur. Tableaux de bord clairs pour le suivi des ventes, clients et factures. Design moderne avec Tailwind CSS.",
    status: "Terminé",
    statusColor: "bg-gray-500",
    category: "frontend",
    image: "https://readdy.ai/api/search-image?query=commercial%20management%20react%20application%20with%20sales%20tracking%20dashboard%20activity%20monitoring%20and%20business%20metrics%20on%20laptop%20in%20contemporary%20office%20with%20soft%20light%20background%20business%20software%20interface&width=800&height=500&seq=maxitfront1&orientation=landscape",
    features: [
      "Suivi des ventes en temps réel",
      "Gestion des clients",
      "Facturation intégrée",
      "Rapports commerciaux",
      "Interface responsive"
    ],
    challenges: [
      "Simplification de workflows complexes",
      "Performance des tableaux de données"
    ],
    results: [
      "Adoption rapide par l'équipe commerciale",
      "Gain de productivité de 25%"
    ]
  },
  {
    id: "note-de-gess",
    title: "Note de Gess – Application de Notes Étudiantes",
    tech: ["Angular", "Firebase", "TypeScript", "GitHub Actions", "SCSS"],
    period: "2022 – 2023",
    description: "Application complète de gestion de notes, déploiement automatisé via GitHub Actions.",
    fullDescription: "Application Angular pour la gestion des notes étudiantes avec Firebase comme backend. Interface intuitive pour enseignants et étudiants, avec calcul automatique des moyennes et génération de bulletins.",
    status: "Terminé",
    statusColor: "bg-gray-500",
    category: "frontend",
    image: "https://readdy.ai/api/search-image?query=student%20grade%20management%20angular%20application%20interface%20with%20academic%20records%20score%20tracking%20and%20educational%20dashboard%20on%20computer%20in%20school%20environment%20with%20clean%20white%20background%20education%20software&width=800&height=500&seq=notegess1&orientation=landscape",
    features: [
      "Saisie des notes par matière",
      "Calcul automatique des moyennes",
      "Génération de bulletins PDF",
      "Suivi de progression",
      "Notifications aux parents"
    ],
    challenges: [
      "Calculs de moyennes pondérées",
      "Gestion des périodes scolaires"
    ],
    results: [
      "Utilisé par 3 établissements",
      "Réduction de 80% du temps de saisie"
    ]
  },
  // Mobile Projects
  {
    id: "quizzboard-mobile",
    title: "QuizzBoard Mobile – App de Quiz Interactifs",
    tech: ["Flutter", "Dart", "REST API", "JWT", "Google Sign-In", "WebSocket", "Push Notifications", "Secure Storage"],
    period: "2026",
    description: "Application mobile QuizzBoard pour rejoindre des sessions par code, créer des sessions, répondre aux quiz, suivre les résultats et recevoir des notifications.",
    fullDescription: "QuizzBoard Mobile est l'application mobile de l'écosystème QuizzBoard. Elle permet aux apprenants et professeurs d'utiliser les principales fonctionnalités de la plateforme depuis un smartphone : authentification, onboarding, choix du profil, sessions, participation par code, salle d'attente, création de session, quiz avec timer, résultats, classement, historique, notifications, messages, profil et paramètres. L'application communique avec la même API REST que la plateforme web afin de synchroniser utilisateurs, quiz, sessions, participations et résultats. Le backend reste l'autorité pour valider les codes, enregistrer les réponses, calculer les scores et protéger les parcours compétitifs.",
    status: "Mobile",
    statusColor: "bg-[#FFD700]",
    category: "mobile",
    image: "/images/projects/quizzboard-mobile-showcase.png",
    gallery: [
      "/images/projects/quizzboard-mobile-showcase.png",
      "/images/projects/quizzboard-showcase.png"
    ],
    features: [
      "Connexion, inscription, Google Sign-In et choix du profil",
      "Accueil différencié apprenant/professeur avec actions rapides",
      "Rejoindre une session avec code ou QR code",
      "Création de session mobile avec code de participation",
      "Salle d'attente, participants et démarrage de session",
      "Quiz avec timer, progression, validation des réponses et résultats",
      "Notifications, historique, profil, paramètres et gestion réseau"
    ],
    challenges: [
      "Synchroniser mobile et web sur le même backend QuizzBoard",
      "Gérer les états de session en temps réel avec WebSocket",
      "Sécuriser le stockage du token et la validation des réponses",
      "Maintenir une expérience claire en cas de perte de connexion"
    ],
    results: [
      "Application mobile complète pour participer aux quiz depuis smartphone",
      "Parcours professeur disponible pour créer et partager une session",
      "Score, correction et classement consultables après participation",
      "Version mobile structurée pour APK de test et publication production"
    ]
  },
  {
    id: "kapa-connect",
    title: "KAPA Connect – Suivi Scolaire & Présence QR",
    tech: ["Flutter", "React.js", "NestJS", "TypeScript", "PostgreSQL", "JWT", "QR Code", "SMS", "Push Notifications", "Docker"],
    period: "2026",
    description: "Plateforme multi-écoles reliant parents, élèves, personnel et établissements avec suivi de présence par QR Code, alertes parents, devoirs, documents et messagerie.",
    fullDescription: "KAPA Connect, Kid Alert for Parents Connect, est une plateforme scolaire pensée pour connecter l'école et rassurer les parents. Le coeur du projet est le suivi sécurisé de présence des élèves grâce à des QR Codes : arrivée, sortie, retards, absences automatiques et sorties exceptionnelles sont enregistrés, historisés et notifiés aux parents. Le système combine une application mobile parent, une plateforme web pour enseignants/personnel et une administration école multi-établissements. Il centralise aussi devoirs, cours, documents, annonces, messagerie parent-école, statistiques, rapports, rôles, permissions et audit logs. L'architecture recommandée repose sur un backend NestJS en monolithe modulaire, PostgreSQL, JWT avec refresh token, isolation des données par école, notifications push, SMS et synchronisation offline pour les scans lorsque la connexion est instable.",
    status: "En conception",
    statusColor: "bg-[#8B5CF6]",
    category: "mobile",
    image: "/images/projects/kapa-connect-web-showcase.png",
    gallery: [
      "/images/projects/kapa-connect-web-showcase.png",
      "/images/projects/kapa-connect-dashboard-mobile.png",
      "/images/projects/kapa-connect-parent-app.png"
    ],
    features: [
      "Suivi de présence par QR Code unique pour chaque élève",
      "Détection automatique des retards et absences selon les horaires de l'école",
      "Notifications push et SMS pour les événements critiques",
      "Application parent avec suivi des enfants, historique, devoirs et documents",
      "Plateforme web professeur/personnel pour scans, classes, devoirs et messages",
      "Administration multi-écoles avec classes, élèves, parents, QR codes et rapports",
      "Mode offline avec file de synchronisation et gestion des conflits"
    ],
    challenges: [
      "Garantir l'isolation des données entre établissements",
      "Gérer les scans QR hors ligne sans doublons ni incohérences",
      "Sécuriser les données sensibles des élèves et des familles",
      "Concevoir des règles métier configurables pour retards, absences et sorties"
    ],
    results: [
      "Parents informés en temps réel de l'arrivée, du retard ou de l'absence d'un enfant",
      "Traçabilité complète des présences, sorties exceptionnelles et saisies manuelles",
      "Communication école-parent centralisée autour des devoirs, documents et messages",
      "Architecture prête pour un produit SaaS scolaire multi-écoles"
    ]
  },
  {
    id: "dailycatch-mobile",
    title: "DailyCatch – Marketplace Mobile Anti-Gaspillage",
    tech: ["Flutter", "Dart", "REST API", "JWT", "Firebase", "Geolocation", "PostgreSQL", "PostGIS", "Docker", "Nginx"],
    period: "2026",
    description: "Application mobile anti-gaspillage pour produits alimentaires et produits de la mer : géolocalisation, offres proches, réservation de paniers et retrait avec code QR.",
    fullDescription: "DailyCatch est une marketplace mobile anti-gaspillage permettant aux vendeurs, poissonneries, restaurants et commerces de proposer des produits ou paniers invendus à prix réduit. Les acheteurs découvrent les offres autour d'eux grâce à la géolocalisation, consultent les détails, réservent un panier puis paient sur place au moment du retrait. L'application comprend un espace acheteur, un espace vendeur et une administration web. Le vendeur peut créer ses paniers, gérer les stocks, suivre les commandes, scanner un code de retrait et consulter ses statistiques. Le backend reste l'autorité métier pour les réservations, stocks, codes QR et validations, avec JWT, RBAC, Firebase Cloud Messaging, stockage média, Docker, VPS Linux et CI/CD.",
    status: "Mobile",
    statusColor: "bg-[#FFD700]",
    category: "mobile",
    image: "/images/projects/dailycatch-showcase.png",
    gallery: [
      "/images/projects/dailycatch-cover.png",
      "/images/projects/dailycatch-map-list.png",
      "/images/projects/dailycatch-showcase.png"
    ],
    features: [
      "Découverte d'offres par géolocalisation, carte et liste",
      "Réservation de paniers avec paiement sur place",
      "Code de retrait et QR code validés côté backend",
      "Espace vendeur pour créer offres, gérer stocks et commandes",
      "Notifications push Firebase sur les changements de statut",
      "Messagerie acheteur/vendeur et avis après retrait",
      "Administration web pour vendeurs, offres, signalements et statistiques"
    ],
    challenges: [
      "Éviter la surréservation lors de stocks limités",
      "Sécuriser la validation des codes de retrait et QR codes",
      "Gérer les permissions acheteur, vendeur et administrateur",
      "Assurer une expérience fluide avec géolocalisation et réseau instable"
    ],
    results: [
      "Parcours de réservation simple sans paiement en ligne",
      "Valorisation des invendus et réduction du gaspillage alimentaire",
      "Workflow complet vendeur : offre, commande, retrait, statistiques",
      "Architecture mobile prête pour Android, iOS, notifications et mode offline"
    ]
  },
  {
    id: "messaging-app",
    title: "Messaging App (WhatsApp Clone)",
    tech: ["Flutter", "Dart", "Firebase"],
    period: "2025",
    description: "Application mobile de messagerie temps réel avec chat, statuts en ligne, partage de médias, notifications push.",
    fullDescription: "Clone WhatsApp développé avec Flutter, offrant toutes les fonctionnalités essentielles de messagerie : chat temps réel, statuts, partage de médias, appels vocaux. Firebase assure le backend temps réel et les notifications push.",
    status: "Mobile",
    statusColor: "bg-[#FFD700]",
    category: "mobile",
    github: "https://github.com/brahim1205/WhatsApp-Project",
    image: "https://readdy.ai/api/search-image?query=modern%20mobile%20messaging%20app%20interface%20on%20smartphone%20screen%20showing%20chat%20conversations%20with%20clean%20whatsapp%20style%20design%20held%20in%20hand%20against%20soft%20gradient%20background%20mobile%20communication%20app%20aesthetic&width=800&height=500&seq=whatsapp1&orientation=landscape",
    features: [
      "Chat temps réel",
      "Statuts en ligne/hors ligne",
      "Partage de photos et vidéos",
      "Notifications push",
      "Chiffrement des messages"
    ],
    challenges: [
      "Synchronisation temps réel fiable",
      "Optimisation batterie"
    ],
    results: [
      "Performance comparable à WhatsApp",
      "Projet open source populaire"
    ]
  },
  {
    id: "task-management-app",
    title: "Task Management App",
    tech: ["Flutter", "REST API", "JWT"],
    period: "2025",
    description: "Application mobile de gestion de tâches collaboratives avec authentification, filtres, notifications, UI responsive.",
    fullDescription: "Application de productivité Flutter pour la gestion de tâches en équipe. Interface intuitive avec drag & drop, filtres avancés, et synchronisation cloud. Parfaite pour les équipes agiles.",
    status: "Mobile",
    statusColor: "bg-[#FFD700]",
    category: "mobile",
    image: "https://readdy.ai/api/search-image?query=flutter%20task%20management%20mobile%20app%20on%20smartphone%20displaying%20todo%20lists%20kanban%20board%20and%20productivity%20features%20with%20modern%20ui%20design%20against%20clean%20minimal%20background%20productivity%20app%20interface&width=800&height=500&seq=taskapp1&orientation=landscape",
    features: [
      "Gestion de tâches drag & drop",
      "Collaboration en équipe",
      "Filtres et recherche",
      "Rappels et notifications",
      "Mode hors ligne"
    ],
    challenges: [
      "Synchronisation offline/online",
      "UX mobile optimale"
    ],
    results: [
      "Note de 4.5/5 sur les stores",
      "Utilisé par plusieurs équipes"
    ]
  },
  {
    id: "event-management-app",
    title: "Event Management App",
    tech: ["Flutter", "Stripe API"],
    period: "2024",
    description: "Application mobile pour la gestion d'événements et billetterie avec paiements en ligne, QR codes, tableau de bord.",
    fullDescription: "Solution complète de gestion d'événements avec Flutter. Création d'événements, vente de billets via Stripe, génération de QR codes pour le contrôle d'accès, et tableau de bord organisateur.",
    status: "Mobile",
    statusColor: "bg-[#FFD700]",
    category: "mobile",
    image: "https://readdy.ai/api/search-image?query=event%20ticketing%20mobile%20application%20on%20phone%20screen%20showing%20event%20listings%20qr%20code%20tickets%20and%20payment%20interface%20with%20elegant%20design%20against%20soft%20neutral%20background%20event%20management%20app&width=800&height=500&seq=eventapp1&orientation=landscape",
    features: [
      "Création et gestion d'événements",
      "Billetterie en ligne Stripe",
      "QR codes pour accès",
      "Scanner de billets",
      "Statistiques en temps réel"
    ],
    challenges: [
      "Intégration paiement mobile",
      "Génération et validation QR codes"
    ],
    results: [
      "Plusieurs événements gérés avec succès",
      "Taux de fraude de 0%"
    ]
  },
  {
    id: "marketplace-mobile-app",
    title: "Marketplace Mobile App",
    tech: ["Flutter", "Firebase", "Node.js"],
    period: "2025",
    description: "Application marketplace avec upload obligatoire de photos, gestion des rôles, chat temps réel, cache et sécurité.",
    fullDescription: "Marketplace mobile complète pour l'achat et la vente de produits. Upload de photos obligatoire pour la qualité des annonces, chat intégré entre acheteurs et vendeurs, système de notation et de confiance.",
    status: "Mobile",
    statusColor: "bg-[#FFD700]",
    category: "mobile",
    image: "https://readdy.ai/api/search-image?query=marketplace%20mobile%20app%20interface%20on%20smartphone%20with%20product%20listings%20photo%20uploads%20and%20shopping%20features%20modern%20ecommerce%20design%20against%20clean%20white%20background%20mobile%20shopping%20application&width=800&height=500&seq=marketplace1&orientation=landscape",
    features: [
      "Publication d'annonces avec photos",
      "Chat temps réel acheteur/vendeur",
      "Système de notation",
      "Recherche géolocalisée",
      "Favoris et alertes"
    ],
    challenges: [
      "Modération du contenu",
      "Performance avec nombreuses images"
    ],
    results: [
      "Milliers d'annonces publiées",
      "Communauté active d'utilisateurs"
    ]
  }
];

export const getProjectById = (id: string): Project | undefined => {
  return projects.find(project => project.id === id);
};

export const getProjectsByCategory = (category: 'backend' | 'frontend' | 'mobile'): Project[] => {
  return projects.filter(project => project.category === category);
};
